import { render } from "./LeaveCalender.vue?vue&type=template&id=10a3142e&scoped=true"
import script from "./LeaveCalender.vue?vue&type=script&lang=js"
export * from "./LeaveCalender.vue?vue&type=script&lang=js"

import "./LeaveCalender.vue?vue&type=style&index=0&id=10a3142e&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a3142e"]])

export default __exports__